const { useEffect } = require('react');

const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} - Probashi Seba`;
  }, [title]);
};

export default useTitle;
